var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column",staticStyle:{"justify-content":"center","align-items":"center","height":"100%"}},[_c('img',{staticStyle:{"width":"2.4rem","height":"2.4rem"},attrs:{"src":require("../img/IdCard.png")}}),_c('p',{staticStyle:{"font-size":"0.7rem","font-weight":"bold"}},[_vm._v("请读取司机身份证")])])
}]

export { render, staticRenderFns }